export default {
    BACKEND_URL: process.env.VUE_APP_BACKEND_URL || 'http://localhost:8000/api',
    BACKEND_URL_SENTRY: process.env.VUE_APP_BACKEND_URL_SENTRY || 'http://localhost:8000/api',
    SENTRY_DSN: process.env.VUE_APP_SENTRY_DSN || '',
}